import { HttpErrorResponse } from '@angular/common/http';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ProfileService } from '@core/services/profile.service';
import { CustomValidator } from '../..';
import { SuceesChangepasswordComponent } from '../sucees-changepassword/sucees-changepassword.component';

import { passwordValidator } from '../../services/custom-validatior.abstract';
import { DialogControlService } from '../../services/dialog-control.service';
import { autoUnsubWith } from '@shared/services/utility.abstract';

@Component({
  selector: 'app-reset-password-modal',
  templateUrl: './reset-password-modal.component.html',
  styleUrls: ['./reset-password-modal.component.scss']
})
export class ResetPasswordModalComponent implements OnInit{
  readonly destroyRef = inject(DestroyRef);
  resetPasswordForm: FormGroup;
  errorMessage : boolean = false;
  errorMessageOld : boolean = false;
  errorMessageOldMess :string;
  constructor(private readonly fb: FormBuilder,
    public readonly ref: DynamicDialogRef,
    private readonly service: ProfileService,
    private readonly dialogControlService : DialogControlService) { }

  ngOnInit() {
    
    this.resetPasswordForm = this.fb.group({
      oldPassword: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(15)]],
      newPassword: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(15),passwordValidator]],
      confirmPassword: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(15),passwordValidator]],
    });
  }

  resetPassword(data): void {
    if (this.resetPasswordForm.valid) {
      this.errorMessageOld = false;
      this.errorMessage = false;
      if (data.newPassword === data.confirmPassword) {
        
        const requestParams = {
          oldPassword: this.resetPasswordForm.get('oldPassword').value,
          newPassword: this.resetPasswordForm.get('newPassword').value
        }
        this.service.resetUserPassword(requestParams)
        .pipe(
          autoUnsubWith(this.destroyRef)
        )
        .subscribe({
          next: (_res: any) => {
            const ref = this.dialogControlService.openDialog(SuceesChangepasswordComponent, {
              width: '30%',
            });
            
            setTimeout(()=>{
              this.closeDialog();
            },1000);
           
          },
          error: (er: HttpErrorResponse) => {
            this.errorMessageOld = true;
            this.errorMessageOldMess = er.error.message;
            
          }
        });
      } else {
        
        setTimeout(() => {
          
          this.errorMessage = true
        }, 1000);
      }
    } else {
      CustomValidator.markFormGroupTouched(this.resetPasswordForm)
    }
  }

  closeDialog() {
    this.ref.close();
  }

  onPasswordKeyDown(event: KeyboardEvent, controlName: string): void {
    const maxLength = 15;
    const control = this.resetPasswordForm.get(controlName);
    const currentValueLength = control?.value.length ?? 0;

    if (currentValueLength >= maxLength && event.key !== 'Backspace' && event.key !== 'Delete') {
      event.preventDefault();
    }
  }
}
